import { sql } from "drizzle-orm";

import type { WsAudioEncoding } from "@storyboard/web-client";
import { bulkInsert } from "@/db/bulkInsert";
import { audioEncoding } from "@/db/schema";
import { deduplicateByKeyValue } from "@/models/appSyncFunctions.ts";
import { emitTableUpdates } from "../eventing/TableEventManager";

const transformWsAudioEncoding = (r: WsAudioEncoding) => ({
  id: r.id,
  contentId: r.contentId,
  createdAt: r.createdAt,
  codec: r.codec,
  duration: r.duration.toString(),
  generatedService: r.generatedService,
  url: r.url,
  generatedVoice: r.generatedVoice,
  language: r.language,
  mimeType: r.mimeType,
  priority: r.priority,
  transcriptionId: r.transcriptionId,
  transcriptionType: r.transcriptionType,
  translatedFrom: r.translatedFrom,
});

export async function bulkUpsertWsAudioEncodings(audioEncodingRecords: WsAudioEncoding[], deferEmit = false) {
  const dataSet = audioEncodingRecords.map((r) => transformWsAudioEncoding(r));
  const deduped = deduplicateByKeyValue(dataSet, (item) => item.id);
  await bulkInsert(audioEncoding, deduped, {
    onConflict: {
      type: "doUpdate",
      target: [audioEncoding.id],
      set: {
        contentId: sql`excluded."contentId"`,
        createdAt: sql`excluded."createdAt"`,
        codec: sql`excluded."codec"`,
        duration: sql`excluded."duration"`,
        generatedService: sql`excluded."generatedService"`,
        url: sql`excluded."url"`,
        generatedVoice: sql`excluded."generatedVoice"`,
        language: sql`excluded."language"`,
        mimeType: sql`excluded."mimeType"`,
        priority: sql`excluded."priority"`,
        transcriptionId: sql`excluded."transcriptionId"`,
        transcriptionType: sql`excluded."transcriptionType"`,
        translatedFrom: sql`excluded."translatedFrom"`,
      },
    },
  });
  if (!deferEmit) {
    emitTableUpdates(["audio_encoding"]);
  }
}
